import { render, staticRenderFns } from "./priorityArchive.vue?vue&type=template&id=fba2afa2&"
import script from "./priorityArchive.vue?vue&type=script&lang=js&"
export * from "./priorityArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports